import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserApi} from "../../services/user-api.service";
import {MessageService} from "../../shared/message.service";
import {ApiError} from "../../services/error";

@Component({
  selector: 'app-login-by-link',
  templateUrl: './login-by-link.component.html',
  styleUrls: ['./login-by-link.component.scss']
})
export class LoginByLinkComponent {
  form: FormGroup;

  constructor(fb: FormBuilder, private api: UserApi, private messageService: MessageService) {
    this.form = fb.group({
      email: ['', [Validators.required]],
    })
  }

  submit() {
    this.api.sendLoginLinkWithEmail(this.form.get('email').value)
      .subscribe(
        () => {
          this.messageService.showSuccess(`Wir haben Dir eine Mail an mit dem Link zum Login geschickt.`);
          // this._router.navigate(["/login"]);
        },
        (error: ApiError) => {
          this.messageService.showError(error.getDisplayMessage())
        }
      );
  }
}
